module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAAM5JREFUKBWtkL0KwjAUhRN/Nl/C1cVFhOLgoA6+hYuP4eJTiC/kpLsIHTs5qnSR+KUkEmzDTcHA6SU53z3JrVLCMsYMBES2CbnLlEAQUgqI6khAiv+fEJ47T7ktxtA/Vk0zc6Z9U+iH54H/rI0D2AfIqRMP2so+o9yovz3d2EtWwIUNQiXK3L42uvUbQ9zNPugdC3BcFfIC+v4Da/jF+VII6OE/7EsuaOYb21T6Fuik+axpPKA9urYIGcHu0KYag6Apmy0aopRlgHJ01FqfP4unn5JuQ7r0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon__dl--white.png
// module id = DeDB
// module chunks = 1